module.exports = __webpack_public_path__ + "img/main_title.26de921d.png";